<template>
	<div class="bg-gray">
		<div class="content">
			<div class="head-bg" :style="`background: url(${headBg}) no-repeat;backgroundSize:cover;`">
				<div class="container">
					<!-- <h2 class="text-white">{{name}}</h2> -->
				</div>
			</div>
		</div>

		<div class="container">
			<div class="types">
				<div class="reback"><a class="color-1a" href="javascript:window.history.go(-1);"> 返回 <a-icon type="rollback" /></a></div>
				<div class="item">
					<div class="title">直播专题</div>
					<ul class="list">
						<li @click="changeSpecial('')" :class="currentSepcial==''?'active':''">全部</li>
						<li @click="changeSpecial(item)" v-for="(item,index) in specialList" :class="currentSepcial.id==item.id?'active':''" :key="index">{{item.roadshowSpecial}}</li>
					</ul>
				</div>
				<div class="item">
					<div class="title">直播类型</div>
					<ul class="list">
						<li @click="changeType('')" :class="currentType==-''?'active':''">全部</li>
						<li @click="changeType(item)" v-for="(item,index) in typeList" :key="index"  :class="currentType.id==item.id?'active':''">{{item.roadshowType}}</li>
					</ul>
				</div>
				<div class="item">
					<div class="title">直播时间</div>
					<ul class="list">
						<li :class="currentDay==item?'active':''" v-for="(item,index) in days" @click="changeDay(item)">{{item}}</li>
					</ul>
				</div>
			</div>
			
			<div class="roads">
				<div v-if="list.records!=''">
					<div v-for="(item,index) in list.records" :key="index">
						<RoadShowCard @click="toJump" :item="item"></RoadShowCard>
					</div>
				</div>
				<div v-else>
					<a-empty :description="false" />
				</div>
				<div class="pages">
					<!-- <a-pagination :default-current="1"  v-model:pageSize="pageSize" :total="list.total" @change="onChange" /> -->
					<a-pagination v-model:current="page" :total="total"  show-less-items @change="onChange" />
				</div>
			</div>
		</div>

	</div>
</template>

<script>
	import RoadShowCard from "@/components/RoadShow/RoadShowCard"
	export default {
		components: {
			RoadShowCard
		},
		data() {
			return {
				headBg: "",
				menuPosition: "",
				name: "",
				imgPath: "",
				roadshowId:"",
				list:'',
				page:1,
				pageSize:10,
				total:0,
				specialList:[], //专题
				typeList:[], //类型列表
				currentSepcial:'',
				currentType:'',
				days:['全部','今天','本周','本月'],
				currentDay:'全部',
				currentTimes:"",
			}
		},
		mounted() {
			document.title = "雄安股权交易所-培训路演";
			this.menuPosition = this.$route.query.menuPosition;
			this.name = this.$route.query.queryName;
			this.roadshowId = this.$route.query.roadshow;
			this.imgPath = this.$api.baseUrl + this.$api.imgPath;
			this.getHeadBanner();
			this.getNearRoadList();
			this.getTypeList();
			this.getSpecialList();
		},
		created() {
			
		},
		methods: {
			toJump(data){
				this.$router.push({path:"/roadshow/info",query:{menuPosition:this.menuPosition,roadshow:data}})
			},
			//切换专题
			changeSpecial(item){
				this.currentSepcial = item;
				this.page = 1;
				this.getNearRoadList();
			},
			// 切换类型
			changeType(item){
				this.currentType = item;
				this.page = 1;
				this.getNearRoadList();
			},
			// 切换日期
			changeDay(item){
				this.currentDay = item;
				if(this.currentDay=='全部'){
					this.currentTimes = '';
				}else if(this.currentDay=='今天'){
					this.currentTimes = "1";
				}else if(this.currentDay == '本周'){
					this.currentTimes = "3";
				}else if(this.currentDay == '本月'){
					this.currentTimes == "4";
				}
				this.page = 1;
				this.getNearRoadList();
			},
			// 分页切换
			onChange(data){
				this.page = data;
				this.getNearRoadList();
			},
			//获取类型列表
			getTypeList(){
				this.$request({
					url:this.$api.roadshow.queryRoadshowTypeList,
					data:{roadshowId:this.roadshowId}
				}).then((res)=>{
					this.typeList = res.data.result;
				})
			},
			//检查状态
			checkStatus(begin,end){
				let beginDate = new Date(begin);
				let endDate = new Date(end);
				let now = new Date();
				let status;
				if(now < beginDate){
					status = 0;
				}else if(now >= beginDate && now < endDate){
					status = 1;
				}else{
					status = -1;
				}
				
				return status;
			},
			//获取专题分类
			getSpecialList(){
				this.$request({
					url:this.$api.roadshow.queryRoadshowSpecialList,
					data:{roadshowId:this.roadshowId}
				}).then((res)=>{
					this.specialList = res.data.result;
				})
			},
			//获取活动列表
			getNearRoadList(){
				this.$request({
					url:this.$api.roadshow.queryRoadshowDetailsList,
					data:{
						roadshowSpcialId:this.currentSepcial.id || '',
						roadshowId:this.roadshowId || '',
						roadshowTypeId:this.roadshowTypeId || '',
						times:this.currentTimes,
						pageNo:this.page,
						pageSize:this.pageSize
					}
				}).then((res)=>{
					this.list = res.data.result;
					this.total = res.data.result.total;
					this.list.records.forEach((item)=>{
						item.status = this.checkStatus(item.beginTime,item.endTime)
					});
				})
			},
			// 顶部背景
			getHeadBanner() {
				this.$request({
					url: this.$api.public.getBanner,
					data: {
						menuPosition: this.menuPosition,
						type: 1
					}
				}).then((res) => {
					this.headBg = this.$api.baseUrl + this.$api.imgPath + res.data.result[0].pcImageUrl;
				})
			},
		}
	}
</script>

<style scoped>
	ul{
		margin:0;
		padding:0;
	}
	ul li{
		
	}
	
	.pages{
		margin-top: 32px;
		display: flex;
		justify-content: center;
	}
	
	.head-bg {
		width: 100%;
		height: 300px;
	}
	
	.head-bg h2 {
		font-size: 36px;
		padding-top: 142px;
	}

	.head-bg p {
		font-size: 24px;
	}

	.types {
		width: 100%;
		padding: 40px;
		background-color: white;
		border-radius: 8px;
		margin-top: -50px;
		margin-bottom: 18px;
		position: relative;
	}
	
	.types .reback{
		position: absolute;
		right:30px;
		top:25px;
		font-size: 16px;
	}

	.types .item {
		margin-bottom: 40px;
		display: flex;
		align-items: center;
		
	}

	.types .item:nth-last-of-type(1) {
		margin-bottom: 0px;
	}

	.types .item .title {
		font-size: 16px;
		color: #666;
		width:80px;
		font-weight: bold;
	}
	
	.types .list{
		display: flex;
		flex-flow: row wrap;
		align-items: center;
		margin-left: 32px;
		font-size: 16px;
	}
	
	.types .list li{
		list-style: none;
		margin-right: 20px;
		padding:7px 16px;
		border-radius: 21px;
		cursor: pointer;
	}
	
	.types .list .active{
		background-color: #13B8EE;
		color: white;
		padding:7px 16px;
		border-radius: 21px;
	}
	
	.roads{
		padding:40px;
		background-color: white;
		border-radius: 8px;
		margin-bottom: 30px;
	}
</style>



// WEBPACK FOOTER //
// src/pages/roadshow/list.vue